module.exports = __webpack_public_path__ + "static/media/br-to.b1b81713.svg";